import { useQuery } from 'react-query'
import { notification } from 'antd'

import { QUERY_KEYS } from '@api'

import { MaterialsApi } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los materiales',
  })
}

const useMaterials = (
  documentNumberId?: string | undefined,
  labelforBlocked?: string,
  validAt?: string,
) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.MATERIALS, { documentNumberId, validAt }],
    () => MaterialsApi.getMaterials(documentNumberId, validAt),
    {
      staleTime: 0,
      refetchOnMount: 'always',
      onError,
    },
  )

  const materialsOptions = data
    ?.map(material => ({
      label: material.nameShort,
      value: material.idSap,
    }))
    .sort((a, b) => (a.label.toUpperCase() < b.label.toUpperCase() ? -1 : 1))

  const materialsOptionsSapCode = data
    ?.map(material => ({
      label:
        material.sapItemSupplier?.blockedForNewTickets && labelforBlocked
          ? `${labelforBlocked} ${material.nameShort.concat(
              ' ',
              material.sapCode.replace(/^(0+)/g, ''),
            )}`
          : material.nameShort.concat(' ', material.sapCode.replace(/^(0+)/g, '')),
      value: material.idSap,
    }))
    .sort((a, b) => (a.label.toUpperCase() < b.label.toUpperCase() ? -1 : 1))

  return {
    materials: data,
    materialsOptions,
    materialsOptionsSapCode,
    isLoading,
  }
}

const useMaterialsBySupplier = (supplierCode: number | undefined) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.MATERIALS, { supplierCode }],
    () => MaterialsApi.getMaterialsBySupplier(supplierCode),
    {
      staleTime: Infinity,
      onError,
    },
  )

  return {
    materials: data,
    isLoading,
  }
}

const usePurchaseOrdersByMaterial = (
  supplierCode: number | undefined,
  plantId?: string | undefined,
  validAt?: string,
) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.PURCHASES, { plantId, supplierCode, validAt }],
    () => MaterialsApi.getPurchaseOrdersByMaterial(supplierCode, plantId, validAt),
    {
      staleTime: Infinity,
      onError,
    },
  )

  return {
    purchaseOrders: data?.sort((a, b) => a.DocumentNumberID.localeCompare(b.DocumentNumberID)),
    isLoading,
  }
}

const useGroupsMaterial = () => {
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.GROUPS_MATERIAL],
    MaterialsApi.getByGroupsMaterial,
    {
      staleTime: Infinity,
      onError,
    },
  )

  const groupsMaterial = data
    ?.map(group => ({
      label: group.name,
      value: group.id,
    }))
    .sort((a, b) => (a.label.toUpperCase() < b.label.toUpperCase() ? -1 : 1))

  return {
    groupsMaterial,
    isLoading,
  }
}

export { useMaterials, useMaterialsBySupplier, usePurchaseOrdersByMaterial, useGroupsMaterial }
